var MantleWindow = MantleWindow || {};

(function ($, Drupal) {
  Drupal.behaviors.makeupLookStepsV1 = {
    attach: function (context) {
      var $modules = $('.js-steps-carousel--v1', context);

      function updateResponsive() {
        $modules.each(function () {
          var $module = $(this);
          var isMobile = Unison.fetch.now().name === 'small';

          if ($module.hasClass('slick-initialized')) {
            $module.slick('unslick');
          }
          $module.slick({
            arrows: true,
            infinite: true,
            dots: !isMobile,
            adaptiveHeight: false,
            fade: true,
            customPaging: function (slider, i) {
              return '<span class="look-step-number">' + (i + 1) + '</span>';
            }
          });
        });
      }
      updateResponsive();
      MantleWindow.onResizeWidth(updateResponsive, 'makeupStep', 50);
    }
  };
})(jQuery, Drupal);
